import React from 'react';
import { Modal, message, Button, Switch, Spin } from 'antd';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import { saveGreetingMessage } from 'api/common';
import {} from 'types/common';
import useGreetingMessageExample from 'hooks/useGreetingMessageExample';
import useProspectSettingInfo from 'hooks/useProspectSettingInfo';
import Tips from './components/Tips';
import { EGreetingMessageTony } from 'types/ai';
import { type } from 'os';
// import useMyListedChannels from 'hooks/useMyListedChannels';
// import { updateProviderEmailNotif } from 'api/provider';

type Props = {
    show: boolean;
    onCannel?: () => void;
    onSuccess?: () => void;
    defaultType?: 'write' | 'tips';
};

const GreetingSetUpModal = (props: Props) => {
    const { show, onCannel, onSuccess, defaultType = 'write' } = props;
    const [step, setStep] = React.useState(defaultType);
    const [submiting, setSubmiting] = React.useState(false);
    const [currentStyle, setCurrentStyle] = React.useState<
        EGreetingMessageTony | undefined
    >(undefined);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [currentContentText, setCurrentContentText] = React.useState('');
    const contentRef = React.useRef<HTMLDivElement>(null);
    const savedRangeRef = React.useRef<Range | null>(null);

    const [aiOn, setAiOn] = React.useState(true);

    const [canFetchExample, setCanFetchExample] = React.useState(true);
    const [showExample, setShowExample] = React.useState(false);
    const [messageParams, setMessageParams] = React.useState<
        | {
              messageTone: EGreetingMessageTony | null | undefined;
              customPrompt: string;
          }
        | undefined
    >(undefined);
    const [messageExample, messageExampleLoading] =
        useGreetingMessageExample(messageParams);
    const [prospectSetting, prospectSettingLoading, fetchProspectSetting] =
        useProspectSettingInfo();
    const [isSaving, setIsSaving] = React.useState(false);

    const showPlaceHolder =
        (!currentContentText || currentContentText.length === 0) && !aiOn;

    const [styleSetting] = React.useState([
        {
            label: 'Friendly',
            value: EGreetingMessageTony.ADJUST_LENGTH_FRIENDLY,
            // content:
            //     'Write a warm and upbeat greeting to welcome a new patient. Always include [Patient Name], [Appointment Date], [Appointment Time], and [Appointment Type]. Add [Visit Reason] if available. Keep it friendly and encouraging. Remind the patient to complete intake forms in the portal. If a [Meeting Link] is provided, include it directly in the message. Remind the patient to save the provider’s practice phone number [Practice Phone Number], as the provider may call to confirm appointment details. End the message by including the provider’s name and credential.',
            content:
                "Write a warm and upbeat greeting to welcome a new patient as a doctor. You'll be provided the patient's first message to you, as well as the following elements: [Patient Name], [Appointment Date], [Appointment Time], [Appointment Type] and [Visit Reason]. Please provide the telehealth meeting link([Meeting Link]) to the patient if it's available. Your goal is to establish a strong bond with the patient and help patient to feel connected, as well as provide clear guidance for the patients to navigate the next step.",
        },
        {
            label: 'Casual',
            value: EGreetingMessageTony.ADJUST_LENGTH_CASUAL,
            // content:
            //     'Write a casual greeting for a new patient. Use their [Patient Name], [Appointment Date], [Appointment Time], and [Appointment Type]. Add [Visit Reason] if available. Keep it conversational and easy-going. Remind them about intake forms. If a [Meeting Link] is provided, include it directly in the message. Remind the patient to save the provider’s practice phone number [Practice Phone Number], as the provider may call to confirm appointment details. End the message by including the provider’s name and credential.',
            content:
                "Write a casual greeting to welcome a new patient as a doctor. You'll be provided the patient's first message to you, as well as the following elements: [Patient Name], [Appointment Date], [Appointment Time], [Appointment Type] and [Visit Reason]. Please provide the telehealth meeting link([Meeting Link]) to the patient if it's available. Your goal is to establish a strong bond with the patient and help patient to feel connected, as well as provide clear guidance for the patients to navigate the next step.",
        },
        {
            label: 'Empathetic',
            value: EGreetingMessageTony.ADJUST_LENGTH_EMPATHETIC,
            // content:
            //     'Write a caring, supportive welcome for a new patient. Always include [Patient Name], [Appointment Date], [Appointment Time], and [Appointment Type]. If [Visit Reason] is available, acknowledge it with empathy. Reassure the patient that you’re here to help and remind them to complete intake forms in the portal. If a [Meeting Link] is provided, include it directly in the message. Remind the patient to save the provider’s practice phone number [Practice Phone Number], as the provider may call to confirm appointment details. End the message by including the provider’s name and credential.',
            content:
                "Write a aring, supportive welcome for a new patient as a doctor. You'll be provided the patient's first message to you, as well as the following elements: [Patient Name], [Appointment Date], [Appointment Time], [Appointment Type] and [Visit Reason]. Please provide the telehealth meeting link([Meeting Link]) to the patient if it's available. Your goal is to establish a strong bond with the patient and help patient to feel connected, as well as provide clear guidance for the patients to navigate the next step.",
        },
        {
            label: 'Formal',
            value: EGreetingMessageTony.ADJUST_LENGTH_FORMAL,
            // content:
            //     'Write a professional, concise welcome message for a new patient. Always include [Patient Name], [Appointment Date], [Appointment Time], [Appointment Type], and [Visit Reason] if available. The tone should be respectful and clear. Remind the patient to complete intake forms before the appointment. If a [Meeting Link] is provided, include it directly in the message. Remind the patient to save the provider’s practice phone number [Practice Phone Number], as the provider may call to confirm appointment details. End the message by including the provider’s name and credential.',
            content:
                "Write a professional, concise welcome message for a new patient as a doctor. You'll be provided the patient's first message to you, as well as the following elements: [Patient Name], [Appointment Date], [Appointment Time], [Appointment Type] and [Visit Reason]. Please provide the telehealth meeting link([Meeting Link]) to the patient if it's available. Your goal is to establish a strong bond with the patient and help patient to feel connected, as well as provide clear guidance for the patients to navigate the next step.",
        },
    ]);

    const funLabel = [
        'Patient Name',
        'Appointment Date',
        'Appointment Time',
        'Appointment Type',
        'Visit Reason',
        'Meeting Link',
        'Practice Phone Number',
    ];

    // 将文本中的占位符转换为带标签的 HTML
    const renderContentWithLabels = (text: string): string => {
        // 匹配所有 [Placeholder] 格式的占位符
        const placeholderRegex = /\[([^\]]+)\]/g;
        return text.replace(placeholderRegex, (match, placeholderName) => {
            // 添加 contentEditable="false" 使 label 不可编辑
            return `
            <span class="${s.label}" data-placeholder="${match}" contenteditable="false">${placeholderName} 
            <span class="${s.close}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M4 12L12 4M4 4L12 12" stroke="#111827" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span></span>`;
        });
    };

    // 从 HTML 中提取纯文本（用于保存）
    const extractTextFromHTML = (html: string): string => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        // 将标签转换回占位符格式
        const labels = tempDiv.querySelectorAll(`.${s.label}`);
        labels.forEach((label) => {
            const placeholder = label.getAttribute('data-placeholder') || '';
            const textNode = document.createTextNode(placeholder);
            label.parentNode?.replaceChild(textNode, label);
        });
        return tempDiv.innerText || tempDiv.textContent || '';
    };

    const setToTargetAiStyle = (style: EGreetingMessageTony) => {
        setCurrentStyle(style);
        const newContent =
            styleSetting.find((item) => item.value === style)?.content || '';
        setCurrentContentText(newContent);
        // 更新 contentEditable 的内容
        if (contentRef.current) {
            const htmlString = renderContentWithLabels(newContent);
            contentRef.current.innerHTML = htmlString;
        }
    };

    React.useEffect(() => {
        if (!aiOn) {
            //clear
            setCurrentContentText('');
            if (contentRef.current) {
                contentRef.current.innerHTML = '';
            }
        }
    }, [aiOn]);

    React.useEffect(() => {
        if (prospectSetting) {
            if (!prospectSetting.greeting) {
                setAiOn(true);
                setCurrentStyle(EGreetingMessageTony.ADJUST_LENGTH_FRIENDLY);
                setToTargetAiStyle(EGreetingMessageTony.ADJUST_LENGTH_FRIENDLY);
                return;
            }
            setAiOn(prospectSetting.greeting.isAiAssisted);
            setCurrentStyle(
                prospectSetting.greeting.messageTone ||
                    EGreetingMessageTony.ADJUST_LENGTH_FRIENDLY
            );
            const text = prospectSetting.greeting?.isAiAssisted
                ? prospectSetting.greeting.customPrompt
                : prospectSetting.greeting.greetingMessage;
            setCurrentContentText(text || '');
            if (contentRef.current) {
                const htmlString = renderContentWithLabels(text || '');
                contentRef.current.innerHTML = htmlString;
            }
        }
    }, [prospectSetting]);

    React.useEffect(() => {
        if (show && step === 'write') {
            fetchProspectSetting();
        }
    }, [show, step]);

    React.useEffect(() => {
        if (messageExample && showExample) {
            setCanFetchExample(false);
        }
    }, [messageExample, showExample]);

    React.useEffect(() => {
        setCanFetchExample(true);
    }, [currentStyle, currentContentText]);

    // 保存光标位置
    const saveSelection = () => {
        const selection = window.getSelection();
        if (selection && selection.rangeCount > 0 && contentRef.current) {
            const range = selection.getRangeAt(0);
            // 检查光标是否在 contentEditable div 内
            if (contentRef.current.contains(range.commonAncestorContainer)) {
                savedRangeRef.current = range.cloneRange();
            }
        }
    };

    const handleSaveInstruction = async () => {
        setIsSaving(true);
        const data: any = {
            messageTone: currentStyle || '',
            isAiAssisted: aiOn,
            status: prospectSetting?.greeting?.status || 'A',
        };
        if (aiOn) {
            data.customPrompt = currentContentText;
        } else {
            data.greetingMessage = currentContentText;
        }
        const result = await saveGreetingMessage(data);
        if (!result.error) {
            message.success('Greeting has been saved.');
            fetchProspectSetting();
            if (onSuccess) {
                onSuccess();
            }
        }
        setIsSaving(false);
    };

    // 处理内容编辑
    const handleContentInput = (e: React.FormEvent<HTMLDivElement>) => {
        const target = e.currentTarget;
        // 保存光标位置
        saveSelection();
        let html = target.innerHTML;

        // 检查是否有新的占位符需要转换为标签
        const placeholderRegex = /\[([^\]]+)\]/g;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const textContent = tempDiv.textContent || '';

        // 如果文本中包含占位符但 HTML 中没有对应的标签，则转换
        const matches = Array.from(textContent.matchAll(placeholderRegex));
        if (matches.length > 0) {
            matches.forEach((match) => {
                const placeholderText = match[0];
                // 检查是否已经存在对应的标签
                const existingLabel = tempDiv.querySelector(
                    `[data-placeholder="${placeholderText}"]`
                );
                if (!existingLabel) {
                    // 在文本节点中查找并替换
                    const walker = document.createTreeWalker(
                        tempDiv,
                        NodeFilter.SHOW_TEXT,
                        null
                    );
                    let node = walker.nextNode();
                    while (node !== null) {
                        if (node.textContent?.includes(placeholderText)) {
                            const parent = node.parentNode;
                            if (parent) {
                                const text = node.textContent;
                                const parts = text.split(placeholderText);
                                const placeholderName = placeholderText.replace(
                                    /[[\]]/g,
                                    ''
                                );
                                const fragment =
                                    document.createDocumentFragment();

                                parts.forEach((part, index) => {
                                    if (part) {
                                        fragment.appendChild(
                                            document.createTextNode(part)
                                        );
                                    }
                                    if (index < parts.length - 1) {
                                        const labelSpan =
                                            document.createElement('span');
                                        labelSpan.className = s.label;
                                        labelSpan.setAttribute(
                                            'data-placeholder',
                                            placeholderText
                                        );
                                        labelSpan.setAttribute(
                                            'contenteditable',
                                            'false'
                                        );
                                        labelSpan.textContent = placeholderName;

                                        const closeSpan =
                                            document.createElement('span');
                                        closeSpan.className = s.close;
                                        closeSpan.textContent = '×';
                                        labelSpan.appendChild(closeSpan);

                                        fragment.appendChild(labelSpan);
                                    }
                                });

                                parent.replaceChild(fragment, node);
                                break;
                            }
                        }
                        node = walker.nextNode();
                    }
                }
            });
            html = tempDiv.innerHTML;
            target.innerHTML = html;
        }

        // 提取纯文本用于保存
        const text = extractTextFromHTML(html);
        setCurrentContentText(text);
    };

    // 处理键盘事件，特别是 Backspace 键
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        const target = e.currentTarget;
        const selection = window.getSelection();

        if (e.key === 'Backspace' && selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);

            // 如果光标在 label 内部，阻止删除
            const labelElement = (
                range.startContainer.nodeType === Node.TEXT_NODE
                    ? range.startContainer.parentElement
                    : range.startContainer
            ) as HTMLElement;

            if (labelElement && labelElement.classList.contains(s.label)) {
                e.preventDefault();
                return;
            }

            // 如果光标在 label 前面，删除 label
            if (range.startOffset === 0) {
                const { startContainer } = range;
                let nodeToCheck: Node | null = startContainer;

                // 向上查找，找到 label 元素
                while (nodeToCheck && nodeToCheck !== target) {
                    if (nodeToCheck.nodeType === Node.ELEMENT_NODE) {
                        const element = nodeToCheck as HTMLElement;
                        if (
                            element.classList &&
                            element.classList.contains(s.label)
                        ) {
                            e.preventDefault();
                            element.remove();
                            // 更新保存的文本
                            const html = target.innerHTML;
                            const text = extractTextFromHTML(html);
                            setCurrentContentText(text);
                            return;
                        }
                    }
                    nodeToCheck = nodeToCheck.previousSibling;
                }
            }
        }

        // 阻止在 label 内部输入
        if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const labelElement = (
                range.startContainer.nodeType === Node.TEXT_NODE
                    ? range.startContainer.parentElement
                    : range.startContainer
            ) as HTMLElement;

            if (labelElement && labelElement.classList.contains(s.label)) {
                // 如果尝试在 label 内部输入，将光标移到 label 后面
                if (e.key.length === 1 || e.key === 'Enter') {
                    e.preventDefault();
                    const afterLabel = document.createTextNode('');
                    labelElement.parentNode?.insertBefore(
                        afterLabel,
                        labelElement.nextSibling
                    );
                    const newRange = document.createRange();
                    newRange.setStart(afterLabel, 0);
                    newRange.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(newRange);
                }
            }
        }
    };

    // 处理标签删除（点击关闭按钮）
    const handleLabelClick = (e: React.MouseEvent) => {
        const target = e.target as HTMLElement;
        // 检查点击的是否是 close 按钮或其内部的 SVG/path 元素
        const closeButton = target.closest(`.${s.close}`);
        if (closeButton) {
            e.preventDefault();
            e.stopPropagation();
            const label = closeButton.closest(`.${s.label}`);
            if (label && contentRef.current) {
                label.remove();
                // 更新保存的文本
                const html = contentRef.current.innerHTML;
                const text = extractTextFromHTML(html);
                setCurrentContentText(text);
            }
        }
    };

    // 处理点击事件，防止在 label 内部设置光标
    const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const target = e.target as HTMLElement;
        const selection = window.getSelection();

        // 如果点击的是 label（但不是关闭按钮），将光标移到 label 后面
        if (
            target.classList.contains(s.label) &&
            !target.classList.contains(s.close)
        ) {
            e.preventDefault();
            const afterLabel = document.createTextNode('');
            target.parentNode?.insertBefore(afterLabel, target.nextSibling);
            if (selection) {
                const range = document.createRange();
                range.setStart(afterLabel, 0);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    };

    // 在指定位置插入 label 的辅助函数
    const insertLabelAtRange = (
        range: Range,
        labelName: string,
        selection: Selection
    ) => {
        if (!contentRef.current) {
            return;
        }

        // 创建占位符文本
        const placeholderText = `[${labelName}]`;

        // 创建 label 元素
        const labelSpan = document.createElement('span');
        labelSpan.className = s.label;
        labelSpan.setAttribute('data-placeholder', placeholderText);
        labelSpan.setAttribute('contenteditable', 'false');
        labelSpan.textContent = labelName;

        const closeSpan = document.createElement('span');
        closeSpan.className = s.close;
        closeSpan.textContent = '×';
        labelSpan.appendChild(closeSpan);

        // 删除选中的内容（如果有）
        range.deleteContents();

        // 插入 label
        range.insertNode(labelSpan);

        // 将光标移到 label 后面
        const afterLabel = document.createTextNode('');
        labelSpan.parentNode?.insertBefore(afterLabel, labelSpan.nextSibling);
        range.setStart(afterLabel, 0);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);

        // 保存新的光标位置
        savedRangeRef.current = range.cloneRange();

        // 更新保存的文本
        const html = contentRef.current.innerHTML;
        const text = extractTextFromHTML(html);
        setCurrentContentText(text);
    };

    const handleFunLabelClick = (labelName: string) => {
        if (!contentRef.current) {
            return;
        }

        const selection = window.getSelection();
        if (!selection) {
            return;
        }

        let range: Range | null = null;

        // 首先尝试使用保存的最后一次光标位置（因为点击功能标签时，contentEditable 可能失去了焦点）
        if (savedRangeRef.current) {
            try {
                // 检查保存的光标位置是否仍然有效
                if (
                    contentRef.current.contains(
                        savedRangeRef.current.commonAncestorContainer
                    )
                ) {
                    range = savedRangeRef.current.cloneRange();
                }
            } catch (e) {
                // 保存的光标位置已失效，忽略
            }
        }

        // 如果保存的位置无效，检查当前光标是否在 contentEditable div 内
        if (!range && selection.rangeCount > 0) {
            const currentRange = selection.getRangeAt(0);
            if (
                contentRef.current.contains(
                    currentRange.commonAncestorContainer
                )
            ) {
                // 光标在 div 内，使用当前光标位置
                range = currentRange;
            }
        }

        // 如果还是没有有效的光标位置，先让 contentEditable div 获得焦点，然后将光标移到内容末尾
        if (!range) {
            contentRef.current.focus();
            // 等待 focus 完成
            setTimeout(() => {
                if (!contentRef.current) {
                    return;
                }
                const sel = window.getSelection();
                if (sel) {
                    range = document.createRange();
                    range.selectNodeContents(contentRef.current);
                    range.collapse(false); // false 表示移到末尾
                    sel.removeAllRanges();
                    sel.addRange(range);
                    insertLabelAtRange(range, labelName, sel);
                }
            }, 0);
            return;
        }

        // 先让 contentEditable div 获得焦点
        contentRef.current.focus();

        // 恢复光标位置
        selection.removeAllRanges();
        selection.addRange(range);

        // 插入 label
        insertLabelAtRange(range, labelName, selection);
    };

    const onSubmit = async () => {
        try {
            setSubmiting(true);
            // TODO: 实现保存逻辑
            // 获取当前编辑的内容: currentContentText
            // const result = await updateProviderEmailNotif(content);
            // if (result.error) {
            //     message.error(result.error);
            // } else {
            //     message.success('Greeting has been saved');
            //     if (onSuccess) {
            //         onSuccess();
            //     }
            // }
            message.success('Greeting has been saved');
            if (onSuccess) {
                onSuccess();
            }
        } catch (e: unknown) {
            const error = e as { errorFields?: unknown };
            if (error.errorFields) {
                // form error
                return;
            }
            // const msg = e?.toString?.() || 'data error';
            // message.error(msg);
        } finally {
            setSubmiting(false);
        }
    };

    return (
        <Modal
            title="Set up automated new patient greetings"
            closable
            className={commonS.modalFixHeightWrap}
            width="850px"
            onCancel={() => {
                onCannel?.();
            }}
            okText="Save"
            open={show}
            onOk={onSubmit}
            destroyOnClose
            footer={
                <div className={s.footerWrap}>
                    {step === 'tips' ? (
                        <>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setStep('write');
                                }}
                            >
                                Continue
                            </Button>
                            <Button
                                onClick={() => {
                                    onCannel?.();
                                }}
                            >
                                Cancel
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                type="primary"
                                loading={isSaving}
                                disabled={!currentContentText}
                                onClick={handleSaveInstruction}
                            >
                                Save instruction
                            </Button>
                            <Button
                                onClick={() => {
                                    setStep('tips');
                                }}
                            >
                                Back
                            </Button>
                        </>
                    )}
                </div>
            }
            okButtonProps={{ loading: submiting }}
        >
            {step === 'tips' && <Tips />}
            {step === 'write' && (
                <div className={s.wrap}>
                    <div className={s.header}>
                        <div className={s.hLeft}>Write your instruction</div>
                        <div className={s.hRight}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.47963 11.4797L9.02557 6.84192H9.97425L11.5202 11.4797L16.158 13.0257V13.9744L11.5202 15.5203L9.97425 20.1581H9.02557L7.47963 15.5203L2.8418 13.9744V13.0257L7.47963 11.4797Z"
                                    fill="url(#paint0_linear_922_9590)"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M16.2296 5.22975L17.0256 2.84192H17.9743L18.7702 5.22975L21.158 6.02569V6.97437L18.7702 7.77032L17.9743 10.1581H17.0256L16.2296 7.77032L13.8418 6.97437V6.02569L16.2296 5.22975Z"
                                    fill="url(#paint1_linear_922_9590)"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_922_9590"
                                        x1="11.9999"
                                        y1="2.84192"
                                        x2="11.9999"
                                        y2="20.1581"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#0E62F4" />
                                        <stop offset="1" stopColor="#BB5BFF" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint1_linear_922_9590"
                                        x1="11.9999"
                                        y1="2.84192"
                                        x2="11.9999"
                                        y2="20.1581"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#0E62F4" />
                                        <stop offset="1" stopColor="#BB5BFF" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            AI-Assisted
                            <Switch
                                checked={aiOn}
                                onChange={(check: boolean) => {
                                    setAiOn(check);
                                    if (check) {
                                        if (!currentStyle) {
                                            setToTargetAiStyle(
                                                EGreetingMessageTony.ADJUST_LENGTH_FRIENDLY
                                            );
                                        } else {
                                            setToTargetAiStyle(currentStyle);
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                    {aiOn && (
                        <>
                            <div className={s.selectLabel}>
                                Select message tone
                            </div>

                            <div className={s.styleSettingWrap}>
                                {styleSetting.map((item) => {
                                    return (
                                        <div
                                            className={`${s.styleItem} ${
                                                currentStyle === item.value
                                                    ? s.active
                                                    : ''
                                            }`}
                                            key={item.label}
                                            onClick={() => {
                                                setToTargetAiStyle(
                                                    item.value as EGreetingMessageTony
                                                );
                                            }}
                                        >
                                            {item.label}
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}

                    <div className={s.selectLabel}>
                        Personalize with patient details
                    </div>
                    <div className={s.funLabelWrap}>
                        {funLabel.map((item) => {
                            return (
                                <div
                                    onClick={() => {
                                        handleFunLabelClick(item);
                                    }}
                                    className={s.funLabelItem}
                                    key={item}
                                >
                                    {item}
                                </div>
                            );
                        })}
                    </div>
                    <div className={s.cWrap}>
                        <div
                            ref={contentRef}
                            className={s.content}
                            contentEditable
                            onInput={handleContentInput}
                            onKeyDown={handleKeyDown}
                            onBlur={saveSelection}
                            onClick={(e) => {
                                handleContentClick(e);
                                handleLabelClick(e);
                            }}
                            suppressContentEditableWarning
                        />
                        {showPlaceHolder && (
                            <div className={s.placeHolder}>
                                Write your own greeting instructions. Use the
                                chips above to customize your greeting so each
                                patient receives a personalized message with
                                their details, such as name, visit reason, or
                                appointment date and time...
                            </div>
                        )}
                    </div>
                    <div
                        onClick={() => {
                            if (!canFetchExample) {
                                return;
                            }
                            setShowExample(true);
                            setMessageParams({
                                messageTone: aiOn ? currentStyle : null,
                                customPrompt: currentContentText,
                            });
                        }}
                        className={`${s.viewExample} ${
                            canFetchExample ? s.opened : ''
                        }`}
                    >
                        View example
                    </div>
                    {showExample && (
                        <Spin spinning={messageExampleLoading}>
                            <div className={s.exampleWrap}>
                                <div
                                    className={s.exampleContent}
                                    dangerouslySetInnerHTML={{
                                        __html: messageExample,
                                    }}
                                />
                            </div>
                        </Spin>
                    )}
                </div>
            )}
        </Modal>
    );
};

export default GreetingSetUpModal;
